var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import ServiceService from '../../api/ServiceService';
import DetailDialog from "./DetailDialog.vue";
import PayDialog from "./PayDialog.vue";
import { EServiceStatus } from "../../enum/EStatus";
var ServiceTable = (function (_super) {
    __extends(ServiceTable, _super);
    function ServiceTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.serviceStatus = EServiceStatus;
        return _this;
    }
    ServiceTable.prototype.watchNoticeData = function (val) {
        var _this = this;
        this.$nextTick(function () {
            if (val.notice_sub_type == 4 || val.notice_sub_type == 5 || val.notice_sub_type == 6) {
                var params = {
                    service_id: val.notice_params.service_id
                };
                _this.service.getServiceDetail(params).then(function (res) {
                    res.data.data.payment_mode = val.notice_sub_type == 4 ? 2 : 1;
                    if (val.notice_params.order_money) {
                        res.data.data.pending_fee = val.notice_params.order_money.toString();
                    }
                    var data = res.data.data;
                    _this.payService(data, val.notice_params.order_id);
                }).catch(function (err) {
                    _this.$message.error(err.msg || err.message);
                });
            }
            if (val.notice_sub_type == 2) {
                var params = {
                    service_id: val.notice_params.service_id
                };
                _this.service.getServiceDetail(params).then(function (res) {
                    res.data.data.is_trial = 0;
                    var data = res.data.data;
                    _this.toOpenService(data);
                }).catch(function (err) {
                    _this.$message.error(err.msg || err.message);
                });
            }
        });
    };
    Object.defineProperty(ServiceTable.prototype, "Columns", {
        get: function () {
            var start = [], end = [], cols = [], center = [{ prop: "service_name", label: "服务名称", sortable: false, minWidth: "100", toDialogType: true },
                { prop: "is_charge", label: "是否收费", sortable: false, minWidth: "80", toDialogType: false },
                { prop: "payment_mode_name", label: "缴费模式", sortable: false, minWidth: "100", toDialogType: false },
                { prop: "status_name", label: "状态", sortable: false, minWidth: "80", toDialogType: false }];
            switch (this.status) {
                case EServiceStatus.NoOpen:
                    start = [];
                    end = [];
                    break;
                case EServiceStatus.Opened:
                    start = [{ prop: "c_time", label: "开通时间", sortable: false, minWidth: "160", toDialogType: false }];
                    end = [{ prop: "pending_fee", label: "待缴费", sortable: false, minWidth: "100", toDialogType: false },
                        { prop: "payment_time", label: "最近缴费时间", sortable: false, minWidth: "160", toDialogType: false },
                        { prop: "account_period", label: "缴费账期", sortable: false, minWidth: "180", toDialogType: false },
                        { prop: "service_comment", label: "备注", sortable: false, minWidth: "120", toDialogType: false }];
                    break;
                default:
                    break;
            }
            ;
            cols = start.concat(center).concat(end);
            return cols;
        },
        enumerable: true,
        configurable: true
    });
    ServiceTable.prototype.created = function () {
        this.service = ServiceService.getInstance();
    };
    ServiceTable.prototype.toOpenService = function (row) {
        var _this = this;
        var instance = this.$dialog(DetailDialog, {
            data: {
                serviceInfo: row,
                isOpenOperate: true
            }
        }, {
            title: "开通服务",
            width: 640,
            height: row.service_id == 4 ? 220 : 520
        }).instance;
        instance.$on('toOpenPay', function (serviceInfo, paymentInfo) {
            _this.toOpenPay(serviceInfo, paymentInfo);
        });
        instance.$on('trialSuccess', function () {
            _this.$emit('refreshTable', 0);
        });
    };
    ServiceTable.prototype.toOpenPay = function (serviceInfo, paymentInfo) {
        var _this = this;
        var instance = this.$dialog(PayDialog, {
            data: {
                isOpenOperate: true,
                paymentInfo: paymentInfo,
                service_id: serviceInfo.service_id,
                service_name: serviceInfo.service_name,
                payment_mode: serviceInfo.payment_mode
            }
        }, {
            title: "缴费",
            width: 640,
            height: 560
        }).instance;
        instance.$on('paySuccess', function () {
            _this.$message.success('缴费成功！');
            _this.$emit('refreshTable', 1);
        });
    };
    ServiceTable.prototype.payService = function (row, order_id) {
        var _this = this;
        var payment = row.payment_modes.filter(function (item) {
            return item.payment_mode == row.payment_mode;
        });
        var instance = this.$dialog(PayDialog, {
            data: {
                payment_mode: row.payment_mode,
                paymentInfo: payment[0],
                service_id: row.service_id,
                service_name: row.service_name,
                order_money: row.pending_fee.replace(/[^\d.]/ig, ""),
                order_id: order_id
            }
        }, {
            title: "缴费",
            width: 640,
            height: 560
        }).instance;
        instance.$on('paySuccess', function () {
            _this.$message.success('缴费成功！');
            _this.$emit('refreshTable', 1);
        });
    };
    ServiceTable.prototype.viewServiceDetail = function (row) {
        var instance = this.$dialog(DetailDialog, {
            data: {
                serviceInfo: row,
                isOpenOperate: false
            }
        }, {
            title: "服务说明",
            width: 640,
            height: 520
        }).instance;
    };
    __decorate([
        Prop({
            default: {},
            type: Object
        })
    ], ServiceTable.prototype, "noticeData", void 0);
    __decorate([
        Prop({
            default: [],
            type: Array
        })
    ], ServiceTable.prototype, "listData", void 0);
    __decorate([
        Prop({
            default: '0',
            type: String
        })
    ], ServiceTable.prototype, "status", void 0);
    __decorate([
        Watch("noticeData", { immediate: true, deep: true })
    ], ServiceTable.prototype, "watchNoticeData", null);
    ServiceTable = __decorate([
        Component({
            components: {}
        })
    ], ServiceTable);
    return ServiceTable;
}(Vue));
export default ServiceTable;
